import { createContext, useContext } from 'react';

export type RowEditingContextValue = {
  editingRowId: string | null;
  isSaving: boolean;
  isDeleting: boolean;
};

const RowEditingContext = createContext<RowEditingContextValue | null>(null);

export const RowEditingProvider = RowEditingContext.Provider;

export function useRowEditingContext() {
  return useContext(RowEditingContext);
}
